import axios from 'axios';
import { getToken, setToken } from '@/base/store/auth';
import {
  APP_DEFAULT_NETWORK_TIMEOUT, APP_API_UNAUTH_CODE,
  APP_PARAMS_ERROR_CODE, APP_VIDEO_TAKE_DOWN_CODE, APP_PHONE_NOT_BIND_CODE
} from '@/constants';
import adapter from './adapter';
import retry from './retry';
import single from './single';
import auth from './auth';
import { getStorage } from '../store/storage';

const API_BASE_URL = process.env.REACT_APP_API;

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/' : API_BASE_URL,
  timeout: APP_DEFAULT_NETWORK_TIMEOUT,
  transformRequest: [(data, headers) => {
    const token = getToken();
    const promotionId = getStorage('promotion_id') || 0; // 推广链接 id

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    if (promotionId) {
      headers['X-Source-Promotion-Id'] = promotionId;
    }

    headers['Content-Type'] = 'application/json'; // 明确指定 JSON
    
    return data;
  }]
});

request.interceptors.response.use(
  resp => resp.data,
  err => Promise.reject(parseErr(err))
);


request.interceptors.response.use(
  resp => {
    const { code } = resp;
    const errorCodeArr = [APP_PARAMS_ERROR_CODE, APP_VIDEO_TAKE_DOWN_CODE, APP_PHONE_NOT_BIND_CODE, APP_API_UNAUTH_CODE];

    if (errorCodeArr.includes(code)) {
      return Promise.reject(parseErr(resp));
    }

    return resp;
  },
  err => Promise.reject(parseErr(err))
);

function parseErr (err) {
  let status = 0;
  let data = null;
  let code = err.code || 0;
  let msg = err.msg || 'request failed';
  const resp = err.response;

  if (resp) {
    status = resp.status;

    if (resp?.data?.message) {
      data = resp.data.data;
      code = resp.data.code;
      msg = resp.data.message;
    }
  }

  if (code === APP_API_UNAUTH_CODE) {
    setToken('');
  }

  const error = new Error(msg);
  error.status = status;
  error.data = data;
  error.code = code;

  return error;
}

export default auth(single(retry(adapter(request))));
